export default "__VITE_ASSET__32702e86__"